import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { UserService } from "../../shared/services/user.service";
import { User } from "../../shared/services/user.service";
import { PurchaseStateService } from "./../../purchase/shared/services/purchase-state.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-welcome-message",
  templateUrl: "./welcome-message.component.html",
})
export class WelcomeMessageComponent implements OnInit, OnDestroy {
  username: string;
  isCredentialed: boolean;
  instance: string;
  private destroy$ = new Subject<void>();

  constructor(
    private userService: UserService,
    private purchaseState: PurchaseStateService
  ) {
    userService.user$
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => this.userChanged(user));
  }

  ngOnInit() {}

  private userChanged(user: User) {
    if (!user) {
      this.username = null;
      this.isCredentialed = false;
    } else {
      this.username = user.firstName.concat(" ", user.lastName);
      this.isCredentialed = user.credentialHolder;
      this.instance = user.instance;
    }
  }

  get itemCount(): number {
    return this.purchaseState.currentItemCount;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
